var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-player"},[_vm._t("default",function(){return [_vm._v("No content")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }